<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/style.scss';
</style>
<template>
  <el-table
    :data="tableData"
    :header-cell-style="{background: '#F4F4F4', color: '#282828'}"
    :cell-style="{color: '#282828'}"
    border
    height="600"
    style="width: 100%">
    <el-table-column
      label="课程类型"
      align="center"
      width="80">
      <template slot-scope="scope">
        <p>{{ scope.row.type === 1 ? '训练营' : '系列课' }}</p>
      </template>
    </el-table-column>
    <el-table-column
      prop="paperType"
      label="考试类型"
      align="center"
      width="80">
    </el-table-column>
    <el-table-column
      prop="courseName"
      label="课程名称"
      align="center"
      width="200">
    </el-table-column>
    <el-table-column
      prop="title"
      label="考试名称"
      align="center"
      width="100">
    </el-table-column>
    <el-table-column
      label="起始时间"
      align="center"
      width="270">
      <template slot-scope="scope">
        <p>{{scope.row.startTime}} - {{scope.row.endTime}}</p>
      </template>
    </el-table-column>
    <el-table-column
      prop="score"
      label="分数"
      align="center"
      width="50">
    </el-table-column>
    <el-table-column
      label="操作"
      align="center">
      <template slot-scope="scope">
        <el-button
          size="mini"
          type="primary"
          @click="handleFind(scope.row.examId)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  name: 'examTable',
  data () {
    return {}
  },
  methods: {
    handleFind(examId) {
      this.$emit('handleFind', examId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exam/table.vue